import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/example/bg2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-f871621a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "carousel-img",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_carousel = _resolveComponent("n-carousel")!

  return (_openBlock(), _createBlock(_component_n_carousel, {
    effect: "custom",
    "transition-props": { name: 'creative' },
    "show-arrow": "",
    autoplay: "true",
    "centered-slides": "true",
    style: {"width":"100%","height":"60vh"}
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}